var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hzvgshzq0a",
    d: "M16.875 0c.345 0 .625.28.625.625l-.001 8.491 1.434-1.433c.244-.244.64-.244.884 0s.244.64 0 .884l-2.5 2.5c-.025.024-.044.041-.065.056l.065-.056c-.027.026-.055.05-.084.07-.02.015-.042.028-.065.04l-.018.01c-.022.01-.044.02-.067.027l-.019.007c-.066.02-.126.029-.19.029-.062 0-.123-.01-.18-.027l-.027-.009c-.023-.008-.046-.017-.067-.028l-.018-.009c-.023-.012-.045-.025-.065-.04l-.02-.014c-.019-.014-.036-.029-.052-.045l-.012-.011-2.5-2.5c-.244-.245-.244-.64 0-.884s.64-.244.884 0l1.432 1.433V.625c0-.345.28-.625.626-.625zM8.75 8.75c.345 0 .625.28.625.625 0 .346-.28.625-.625.625H4.375c-.345 0-.625-.28-.625-.625 0-.346.28-.625.625-.625H8.75zM10.625 5c.346 0 .625.28.625.625s-.28.625-.625.625H2.5c-.345 0-.625-.28-.625-.625S2.155 5 2.5 5h8.125zm1.932-3.741c.345 0 .625.28.625.625s-.28.625-.625.625H.625C.28 2.509 0 2.229 0 1.884s.28-.625.625-.625h11.932z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 3.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5rerzhfepb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hzvgshzq0a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hzvgshzq0a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D6DCE8",
    mask: "url(#5rerzhfepb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(0 -3.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIconWhite);
export default __webpack_public_path__ + "static/media/sort-icon-white.1f69b2df85b2243c61291ce108e27e49.svg";
export { ForwardRef as ReactComponent };